export default __webpack_public_path__ + "static/media/carticon.8f54c2d7.svg";